import { Pipe, PipeTransform } from '@angular/core';
import { Schedule } from '@app/features/horaires/schedules.model';
import moment from 'moment';

@Pipe({
  name: 'scheduleWeeklyDuration',
  standalone: true,
})
export class ScheduleWeeklyDurationPipe implements PipeTransform {
  transform(value: Schedule[]): string {
    if (!value || value.length === 0) {
      return '00:00';
    }
    const totalMinutes = value.reduce((total, daySchedule) => {
      const dayDuration = daySchedule.slots.reduce((slotsSum, slot) => {
        if (slot.startTime && slot.endTime) {
          const start = moment(slot.startTime, 'HH:mm').diff(moment().startOf('day'), 'minutes');
          const end = moment(slot.endTime, 'HH:mm').diff(moment().startOf('day'), 'minutes');
          const duration = (end - start + 24 * 60) % (24 * 60); // Handle overnight shifts
          return slotsSum + duration;
        }
        return slotsSum;
      }, 0);
      return total + dayDuration;
    }, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
}
